module.exports = __webpack_public_path__ + "img/stock0.5e58cfba.png";